const SELECTED_MODIFIER = '--selected';
const PUBLISHED_PREFIX = 'published_';
const QUANTITY_STRING = 'Quantity';
const ADD_TO_CART_STRING = 'Add to cart';
const ADD_TO_CART_PREORDER_STRING = 'Pre-order now';
const GBP_STRING = 'gbp';
const CONTEXT_KEYS = {
  currencyKey: 'currency',
  variantKey: 'variant',
  cartIdKey: 'cartId',
  cartDataKey: 'cartData',
  selectedAddressKey: 'selectedAddress'
};
const ADDDRESS_LOADED_KEY = 'addressLoaded';
const LOCAL_CART_KEY = 'blaze_cart_id';
const LOCAL_CURRENCY_KEY = 'blaze_cart_currency_code';
const BLAZE_DEFAULT_MIN_QUANTITY = 1;
const DEFAULT_BILLING_ADDRESS = 'Default billing address';
const DEFAULT_SHIPPING_ADDRESS = 'Default shipping address';
const DEFAULT_BILLING_SHIPPING_ADDRESS = 'Default billing/shipping address';

export {
  ADDDRESS_LOADED_KEY,
  BLAZE_DEFAULT_MIN_QUANTITY,
  SELECTED_MODIFIER,
  CONTEXT_KEYS,
  QUANTITY_STRING,
  ADD_TO_CART_STRING,
  ADD_TO_CART_PREORDER_STRING,
  LOCAL_CART_KEY,
  LOCAL_CURRENCY_KEY,
  PUBLISHED_PREFIX,
  GBP_STRING,
  DEFAULT_BILLING_ADDRESS,
  DEFAULT_SHIPPING_ADDRESS,
  DEFAULT_BILLING_SHIPPING_ADDRESS
};
